import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface UserProfile {
  id: string;
  full_name: string;
  phone?: string;
  avatar_url?: string;
  region?: string;
  village?: string;
  farm_size_hectares?: number;
  primary_crop_id?: string;
  farming_experience_years?: number;
  language?: string;
  country_id?: string;
  organization_id?: string;
  simple_mode?: boolean;
  is_onboarded?: boolean;
}

interface UserStore {
  profile: UserProfile | null;
  setProfile: (profile: UserProfile | null) => void;
  updateProfile: (data: Partial<UserProfile>) => void;
  clearProfile: () => void;
}

export const useUserStore = create<UserStore>()(
  persist(
    (set) => ({
      profile: null,

      setProfile: (profile) => set({ profile }),

      updateProfile: (data) =>
        set((state) => ({
          profile: state.profile ? { ...state.profile, ...data } : null,
        })),

      clearProfile: () => set({ profile: null }),
    }),
    {
      name: 'user-storage',
    }
  )
);
